export const featureConfig = {
	isTrueTouchEnabled: true,
	isApiKeyEnabled: true,
	isLipSyncEnabled: true,
	isLightningModelsEnabled: false,
	isShareCanvasEnabled: true,
	isFluxControlNetEnabled: true,
	isChangeItEnabled: false,
	isMusicVideoEnabled: true,
};
